<template>
  <div class="lms-wrapper-two">


    <student-nav v-if="!hideLeftSide">
    </student-nav>

    <div class="lms-content">
      <!-- <course-header
      v-if="$store.state.app.mainLayoutConfig.header != null"
      :navbarmode.sync="navbarMode"
      :course.sync="course"
      @toggle-team-chat="toggleTeamChat"
      :courseMode="courseMode"
    /> -->

      <student-header class="filled" @toggle-navbar="toggleNavbar($event)" :navbarmode.sync="navbarMode" />

      <div class="lms-content-body container course-overview-outer" style="bottom: 0; height: calc(100vh - 80px)"
        v-if="dataRdy">
        <div v-if="boxOt==500">
          <div v-if="taskObj.rdy">
            <!-- {{zoomHasNotStarted(taskObj.task)}} -->
            <div v-if="!zoomIsStarted">
              <zoom-waiting :task="taskObj.task" :isStarted="zoomIsStarted" :course="course"
                @on-detail="showTask" />
            </div>
            <div v-else-if="taskObj.task.i1 == 0" id="zmmtg-dynamic">
              <zoom-detail :task="taskObj.task" />
            </div>
            <div v-else-if="taskObj.task.i1 == 1" id="zmmtg-dynamic">
              <zoom-waiting :task="taskObj.task" :isStarted="zoomIsStarted" :course="course"
                @on-detail="showTask" />
            </div>
            <div v-else-if="
              taskObj.task.i1 == 2 &&
              hasPermission(['learningteacher', 'learningadmin'])
            ">
              <zoom-detail :task="taskObj.task" />
            </div>
            <div v-else id="zmmtg-dynamic">
              <zoom-waiting :task="taskObj.task" :isStarted="zoomIsStarted" :course="course"
                @on-detail="showTask" />
            </div>
          </div>
        </div>
        <div v-else class="pd-30 course-overview">
          <ul class="nav-top nav nav-pills">
            <li class="nav-item">
              <a class="nav-link" :class="{ active: activeSection == 1 }" @click="activeSection = 1" href="#about">Тухай</a>
            </li>
            <li class="nav-item" v-if="course?.teachers?.length>0">
              <a class="nav-link" :class="{ active: activeSection == 2 }" @click="activeSection = 2" href="#teachers">Сургагч
                багш ({{ course.teachers.length }})
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" :class="{ active: activeSection == 3 }" @click="activeSection = 3" href="#lessons">Сургалтын
                хөтөлбөр</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" :class="{ active: activeSection == 4 }" @click="activeSection = 4" href="#reviews">Сургалтын
                үнэлгээ</a>
            </li>
          </ul>
          <div class="d-flex align-items-center mg-b-10">
            <div class="mg-r-10">
              <img
                v-if="course.boxes.filter(x => x.objectTypeId == 396).length && course.boxes.filter(x => x.objectTypeId == 396)[0].tasks.length"
                :src="`${course.boxes.filter(x => x.objectTypeId == 396)[0].tasks[0]['defaultAttachmentUrl']}?w=48&h=48&mode=crop`"
                class="rounded-circle" />
            </div>
            <div class="d-none d-md-block">
              <span class="font-weight-bold tx-16">{{ course.name }}</span>
              <div class="d-flex align-items-center">
                <Rate v-model="course.rateData.rate" :allow-half="true" :disabled="true" size="large"></Rate>

                <div class="text-muted mg-l-10">
                  {{ course.locType.name }}
                </div>
              </div>
            </div>
            <div class="d-md-none d-block">
              <span class="font-weight-medium text-rows-2 tx-14">{{ course.name }}</span>
            </div>
          </div>

          <div class="container-fluid pd-x-0 pd-t-20">

            <div class="d-lg-none d-block inf-footer align-items-center pos-fixed b-0 l-0 wd-100p pd-10" style="z-index: 1100">
              <div class="action align-items-center">
                <button v-if="!course.isJoined" @click="jointToCourse()"
                  class="btn btn-block btn-white mg-b-20 rounded-20">
                  {{ (course.option.joinType == 9900 && course.price == 0 && ($store.state.app.activeGroup.id == 9241 || $store.state.app.activeGroup.id == 9249)) || course.option.directJoin == 1 ? "Элсэх" : "Бүртгүүлэх" }}
                </button>
                <button v-else @click="startCourse()" class="btn btn-block btn-primary">Үзэх</button>
              </div>
            </div>

            <div class="row no-gutters">
              <div class="col-xl-8 col-lg-7 col-md-7 col-sm-12 lsn-maincol">

                <vue-custom-scrollbar :style="`height: calc(100vh - 280px)`"
                  class="scroll-area pos-relative pd-r-20 pd-b-20">
                  <img v-if="$store.state.app.activeGroup.id != 9157" :src="`${course.cover}?w=600`" class="rounded-20" style="max-width: 100%; width: 100%" />
                  <div v-show="sectionManager(0)" id="about" class="section-zone mg-t-20">
                    <div class="section-title mg-b-20">Сургалтын тухай</div>
                    <div v-html="course.info"></div>
                  </div>
                  <div v-show="sectionManager(0)" class="section-zone mg-t-20" v-for="(b, bti) in course.boxes.filter(x => x.ot == 397 && x.tasks.length)" :key="bti">
                    <div class="section-title mg-b-20">{{ b.nm }}</div>
                    <ul class="bullet-list" v-if="b.flag == 1">
                      <li v-for="(t, i) in b.tasks" :key="i">{{ t.task }}</li>
                    </ul>

                    <div class="" v-else-if="(b.flag == 2)">
                      <div class="row ">
                        <div v-for="(t, i) in b.tasks" :key="i" class="col-xxl-4 col-xl-6 col-lg-12 col-md-12">
                          <div class="bg-white rounded-20 d-flex align-items-center pd-20 card-benefit">
                            <div>
                              <div class="mg-r-10 rounded-circle pd-10 icn">
                                <img :src="`${myResBaseUrl}v4-assets/svgicon/interface/outline/check-rectangle.svg`" />
                              </div>
                            </div>
                            {{ t.task }}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="" v-else-if="b.flag == 3">
                      <span v-for="(t, i) in b.tasks" :key="i" class="pd-10 bg-white rounded-20 mg-r-20 mg-b-15"
                        style="display: inline-block">#{{ t.task }}</span>
                    </div>
                  </div>

                  <div v-show="sectionManager(1)" id="teachers" class="section-zone mg-t-20" v-if="course.teachers.length">
                    <div class="section-title mg-b-20">Сургагч багш</div>
                    <div class="bg-white rounded-20 pd-20" v-for="(t, i) in course.teachers" :key="i">
                      <div class="d-flex align-items-center">
                        <div class="mg-r-10">
                          <img @click="showCoursesByTeacher(t.id)" role="button" :src="`${t.cover}?w=138&h=138&mode=crop`"
                            class="rounded-10" />
                        </div>
                        <div>
                          <div @click="showCoursesByTeacher(t.id)" role="button" class="tx-18 font-weight-bold">
                            {{ t.lastName }} {{ t.firstName }}</div>
                          <div class="text-muted mg-y-5">Нэгж: <b>{{ t.depart }}</b></div>
                          <div class="text-muted mg-y-5">Албан тушаал: <b>{{ t.position }}</b></div>
                          <task-rating :taskId.sync="t.id" :allowHalf="true" :showScore="false" class="mg-y-5" />
                          <!-- <div><Rate v-model="4" :allow-half="true" :disabled="true" size="large" ></Rate></div> -->
                          <div @click="showCoursesByTeacher(t.id)" role="button" class="text-muted mg-y-5">Нийт сургалтын
                            тоо: <b>{{ t.allCourseCount }}</b></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-show="sectionManager(2)" id="lessons" class="section-zone mg-t-20">
                    <div class="section-title mg-b-20">Сургалтын хөтөлбөр</div>
                    <!-- <div>
                Сургалтын хөтөлбөрийг харуулахдаа доорх зүйлүүдийг заавал харуулах 
              </div>
              <ul class="bullet-list">
                <li>Сургалтуудыг долоо долоо хоногт хуваах ба нэг долоо хоногт хэдэн цагийг зарцуулах мэдээлэл гарч ирэх.</li>
                <li>Тухайн сургалт дотроо хэдэн видео хэдэн унших материал байгаа тухай мэдээлэл гарч ирэх. </li>
              </ul> -->
                    <div
                      v-if="course.boxes.filter(x => x.objectTypeId == 114).length && course.boxes.filter(x => x.objectTypeId == 114)[0].tasks.length">
                      <div v-if="b.boxes.filter(x => x.attaches.length || x.tasks.length || x.forms.length).length"
                        class="bg-white rounded-20 pd-20 mg-b-20"
                        v-for="(b, i) in course.boxes.filter(x => x.objectTypeId == 114)[0].tasks" :key="i">
                        <div class="d-flex">
                          <div class="bd mg-r-20 pd-y-10 pd-x-20 rounded-10 text-center">
                            <div class="tx-20 font-weight-bold text-black">{{ i + 1 }}</div>
                            <div>{{ course.st6!=undefined && course.st6!=null && course.st6!='' ? course.st6 : 'Week' }}</div>
                          </div>
                          <div class="bd-l pd-l-20">
                            <div class="d-flex align-items-center">
                              <img :src="`${myResBaseUrl}v4-assets/svgicon/interface/outline/layers.svg`" class="ht-16 wd-16 mg-r-10" />
                              <div>Нийт: {{ b.boxes.length }} модуль</div>
                            </div>
                            <div class="font-weight-bold title mg-y-5">
                              {{ b.task }}
                            </div>
                            <div v-if="(b.locType != null)">
                              <!-- Бизнес ба хүний эрхийг бизнесийн үйл ажиллагаандаа хэрхэн хэрэгжүүлэх тухай.  -->
                              {{ b.locType.name }}
                            </div>
                          </div>
                        </div>

                        <div>
                          <table class="wd-100p mg-t-20">
                            <thead>
                              <tr>
                                <th class="pd-b-10 wd-30">#</th>
                                <th class="pd-b-10">Гарчиг</th>
                                <th class="pd-b-10 wd-100">Хугацаа</th>
                                <th class="pd-b-10 wd-150">формат</th>
                              </tr>
                            </thead>

                            <tbody>
                              <tr
                                v-for="(l, i) in b.boxes.filter(x => x.attaches.length || x.tasks.length || x.forms.length)"
                                :key="i" class="bd-t">
                                <td class="title medium">{{ (i + 1) }}</td>
                                <td class="pd-y-10 title medium">{{ l.nm }}</td>
                                <td>
                                  <div class="d-flex align-items-center tx-16">
                                    <img :src="`${myResBaseUrl}v4-assets/svgicon/${l.timeIcon}`" class="ht-16 wd-16 mg-r-5 icon-time" />
                                    <span v-html="l.time"></span>
                                  </div>
                                </td>
                                <td>
                                  <div class="d-flex align-items-center tx-16">
                                    <img :src="`${myResBaseUrl}v4-assets/svgicon/${l.formatIcon}`"
                                      class="ht-16 wd-16 mg-r-5 icon-format" /> {{ l.format }}
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-show="sectionManager(3)" id="reviews" class="section-zone mg-t-20">
                    <div class="section-title mg-b-20">Сургалтын үнэлгээ</div>
                    <div class="bg-white rounded-20 pd-20">
                      <div class="d-flex alifn-tems-center">
                        <div class="font-weight-bolder title" style="font-size: 65px;line-height: 1">
                          {{ (course.rateData.rate).toFixed(2) }}</div>
                        <div class="mg-l-20">
                          <div class="mg-y-10">
                            <Rate v-model="course.rateData.rate" :allow-half="true" :disabled="true" size="large"></Rate>
                          </div>
                          <div>
                            {{ (course.rateData.ratedUserCount * 100 / course.student.count).toFixed(2) }}%,
                            {{ course.rateData.ratedUserCount }} хүн үнэлсэн
                          </div>
                        </div>
                        <!-- <div class="d-flex align-items-center">
                    <div class="text-center pd-l-20">
                      Anhaar !!!
                    </div>
                  </div> -->
                      </div>
                      <div class="mg-t-20">
                        <div class="d-flex align-items-center wd-100p mg-b-10" v-for="(s, i) in  course.rateData.rateStars" :key="i">
                          <div class="wd-30">
                            <img class="wd-20 ht-20 mg-l-2" :src="`${myResBaseUrl}v4-assets/svgicon/interface/outline/star.svg`" />
                          </div>
                          <div class="wd-100 title">{{ s.rate }} үнэлгээ</div>
                          <div class="wd-60p pd-r-10">
                            <div class="progress">
                              <div class="progress-bar" role="progressbar"
                                :style="`width: ${s.userCount * 100 / course.rateData.ratedUserCount}%`"></div>
                            </div>
                          </div>
                          <div class="wd-50 mg-l-auto">{{ course.rateData.ratedUserCount > 0 ?
                            (s.userCount * 100 / course.rateData.ratedUserCount).toFixed(2) : '0' }}%</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="section-zone mg-t-20">
                    <div class="section-title mg-b-20">Нийт 2 сэтгэгдэл</div>
                  </div>
                  <task-notes v-if="course.id > 0" :taskId="course.id" :takeSize="2" :autoHeight="true"
                    @on-attach="onAttach" :obj="{ title: sendObjTitle(), name: course.name }" /> -->

                </vue-custom-scrollbar>
              </div>
              <div class="col-xl-4 col-lg-5 col-md-5 col-sm-12">
                <div class="right-inf-outer pd-x-20">
                  <div class="right-inf pd-20 bg-white rounded-20">
                    <div class="font-weight-bold tx-18 mg-b-20 title">Сургалтын онцлог</div>

                    <nav class="nav nav-sidebar nav-specs tx-13 mg-b-20">
                      <a href="" class="nav-link"><img :src="`${myResBaseUrl}v4-assets/svgicon/interface/outline/check-rectangle.svg`"
                          class="mg-r-10" /> <span>Түвшин:</span> <span class="badge"
                          v-if="course.locType2 != undefined && course.locType2 != null">{{ course.locType2.name }}</span></a>
                      <a href="" class="nav-link"><img :src="`${myResBaseUrl}v4-assets/svgicon/interface/outline/check-rectangle.svg`"
                          class="mg-r-10" /> <span>Шалгалттай эсэх:</span> <span
                          class="badge">{{ course.hasExam ? 'Тийм' : 'Үгүй' }}</span></a>
                      <a v-if="course?.credit" href="" class="nav-link"><img :src="`${myResBaseUrl}v4-assets/svgicon/interface/outline/check-rectangle.svg`"
                          class="mg-r-10" /> <span>Кредит цаг:</span> <span
                          class="badge">{{ course.creditPoint }} <span class="text-muted">цаг</span></span></a>
                      <a href="" class="nav-link"><img :src="`${myResBaseUrl}v4-assets/svgicon/interface/outline/check-rectangle.svg`"
                          class="mg-r-10" /> <span>Сертификаттай эсэх:</span> <span
                          class="badge">{{ course.certificateView ? 'Тийм' : 'Үгүй' }}</span></a>
                      <a href="" class="nav-link"><img :src="`${myResBaseUrl}v4-assets/svgicon/interface/outline/check-rectangle.svg`"
                          class="mg-r-10" /> <span>Эхлэх хугацаа:</span> <span class="badge">{{ course.date.start |
                            moment('YYYY.MM.DD') }}</span></a>
                      <a href="" class="nav-link"><img :src="`${myResBaseUrl}v4-assets/svgicon/interface/outline/check-rectangle.svg`"
                          class="mg-r-10" /> <span>Дуусах хугацаа:</span> <span class="badge">{{ course.date.end |
                            moment('YYYY.MM.DD') }}</span></a>

                    </nav>

                    <!-- {{ course }} -->

                    <div class="inf-footer align-items-center">
                      <div class="action align-items-center">
                        <button v-if="!course.isJoined" @click="jointToCourse()"
                          class="btn btn-block btn-white mg-b-20 rounded-20">
                          
                          {{ (course.option.joinType == 9900 && course.price == 0 && ($store.state.app.activeGroup.id == 9241 || $store.state.app.activeGroup.id == 9249)) || course.option.directJoin == 1 ? "Элсэх" : "Бүртгүүлэх" }}
                        </button>
                        <button v-else @click="startCourse()" class="btn btn-block btn-primary">Үзэх</button>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="course-sidebar d-none">
          <div class="course-sidebar-header">
            <div class="d-flex align-items-center justify-content-between wd-100p">
              <router-link v-if="$route.params.bid > 0 || $route.params.iid > 0" class="wd-50p d-flex course-name"
                role="button" :to="{
                  name: 'lmsCourseView',
                  params: { id: $route.params.id, bid: 0, iid: 0, bot: 0 }
                }">
                <feather type="chevron-left" class="tx-color-02"></feather>
                <div class="text-muted text-uppercase tx-11 pd-t-5">Сургалт</div>
              </router-link>
              <router-link v-else class="wd-50p d-flex course-name" role="button" :to="{
                name: 'lmsCourses',
                params: {
                  md: courseMode.mode,
                  cnm: 'null',
                  type: -1,
                  d1: 'null',
                  d2: 'null'
                }
              }">
                <feather type="chevron-left" class="tx-color-02"></feather>
                <div class="text-muted text-uppercase tx-11 pd-t-5">Сургалтууд</div>
              </router-link>
              <!-- <div class="wd-50p course-percent">
                <div class="progress ht-20">
                  <div
                    class="progress-bar wd-25p"
                    :style="`width: ${course.percent}%`"
                    role="progressbar"
                  >{{course.percent}}%</div>
                </div>
              </div>-->
            </div>
          </div>
          <div class="course-sidebar-body">
            <!-- <div class="pd-t-20 pd-b-10 pd-x-10">
                    <course-nav :boxes="course.boxes"></course-nav>
            </div>-->
            <!-- <course-box
              @toggle-nav="toggleNav"
              :expanded="expanded"
              :boxes="course.boxes"
              :title="course.name"
            ></course-box>-->

            <nav-dynamic v-if="rdy" @on-rebuy="onRebuy" :courseData="course" :hasCourseObj="true"></nav-dynamic>
            <!-- <div @click="toggleNav()" class="lms-nav-toggler" role="button">
              <feather :type="expanded?'chevron-left':'chevron-right'"></feather>
            </div>-->
          </div>
        </div>


        <b-modal v-model="v3mdl" centered content-class="rounded-20 pd-20" scrollable size="xl" hide-footer hide-header
        @hide="onModalHide">
          <div class="course-content-body">
            <div class="d-flex mx-wd-100p-f">
              <div :class="
                `main-area wd-100p pos-relative`
              ">
                <!-- <template v-if="rdy">
              <course-navbar
                @on-toggle-nav="expanded = !expanded"
                @on-toggle-content="toggleContent"
                @on-toggle-right-side="showRightSide = !showRightSide"
                :showRightSide.sync="showRightSide"
                :course="course"
              ></course-navbar>
            </template> -->
                <div v-if="(mode == 2 || mode == 3) && boxOt == 493 && taskObj.rdy">
                  <jitsi-detail :course="course" :task="taskObj.task" @on-jitsi-loaded="cntntNoPdn = true" />
                </div>
                <course-certificate v-else-if="mode == -7" :cid="parseInt($route.params.id, 10)"
                  :style="`height: ${getScrollHeight()}`"></course-certificate>
                <div v-else>
                  <div v-if="mode == 0 && rdy">
                    <course-overview :obj="course" @on-detail="showDetail($event.event, $event.box)"
                      @on-show-exam-result="showExamResult" @show-attach="onAttach" @on-reload="init()" />
                  </div>
                  <div v-else-if="mode == 1 && boxObj.rdy" class="pd-20 pd-lg-25 pd-xl-30">
                    <lesson-list v-if="
                      boxOt == 114 && course.boxes.filter(x => x.ot == 114).length
                    " :tasks="course.boxes.filter(x => x.ot == 114)[0].tasks" @on-detail="showDetail($event)" />
                    <forum-list v-else-if="boxOt == 124" :tasks="boxObj.box.tasks"
                      @on-detail="showDetail($event, boxObj.box.box)" />

                    <template v-else-if="boxOt == 116 || boxOt == 389 || boxOt == 503">

                      <div class="container d-flex justify-content-center ht-100p">
                        <div
                          class="mx-wd-300 wd-sm-450 ht-100p d-flex flex-column align-items-center justify-content-center ">
                          <div class="wd-80p wd-sm-300 mg-b-15">

                            <img v-if="course.percent > 100" src="assets/svg/done.svg" class="img-fluid" alt />
                            <img v-else src="assets/svg/zoom.svg" class="img-fluid" alt />

                          </div>
                          <div v-if="course.percent > 100" class="tx-16 tx-sm-24 text-muted">Бүх хичээлийг үзэж дуусгалаа
                          </div>
                          <div v-lese class="tx-16 tx-sm-24 text-muted">Хичээл үзэлт ({{ course.percent }}%)</div>
                          <p v-if="course.percent > 100" class="tx-color-03 mg-b-10 tx-center">
                            Сургалтад үнэлгээ өгөх үү ?
                          </p>
                          <p v-else class="tx-color-03 mg-b-10 tx-center">
                            Та бүх хичээлийг үзэж дуусгаснаар сургалтад үнэлгээ өгөх боломжтой !
                          </p>
                          <task-rating v-if="course.percent > 100" :taskId.sync="course.id" @on-rated="rateRdy = false"
                            :allowHalf="true" class="mg-b-30" />
                        </div>
                      </div>



                      <form-list backTo="course" :forms="boxObj.box.forms" :box="boxObj.box.box"
                        @on-detail="showDetail($event)" @on-show-exam-result="showExamResult" />
                    </template>
                    <teacher-list v-else-if="boxOt == 396" :tasks="course.teachers"
                      @on-detail="showDetail($event, boxObj.box.box)" />
                    <zoom-list v-else-if="boxOt == 493 || boxOt == 500" :tasks="boxObj.box.tasks" :course="course"
                      @on-detail="showDetail($event, boxObj.box.box)" />
                    <assign-list v-else-if="boxOt == 502" :course="course" />
                  </div>
                  <div v-else-if="mode == 2 || mode == 3">
                    <forum-topic v-if="boxOt == 124 && taskObj.rdy" :task="taskObj.task"
                      @on-detail="showDetail($event, boxObj.box.box)"
                      @on-toggle-class="toggleBodyClass($event.mode, $event.class)" />
                    <teacher-detail v-if="boxOt == 396" :task="taskObj.task" />
                    <form-fill v-if="boxOt == 389" :boxOt="parseInt(boxOt, 10)" backTo="course" />
                    <template v-if="course.percent == 100">
                      <form-fill v-if="boxOt == 503" :boxOt="parseInt(boxOt, 10)" backTo="course" />
                    </template>

                    <div v-if="boxOt == 500 && taskObj.rdy">
                      <!-- {{zoomHasNotStarted(taskObj.task)}} -->
                      <div v-if="!zoomIsStarted">
                        <zoom-waiting :task="taskObj.task" :isStarted="zoomIsStarted" :course="course"
                          @on-detail="showTask" />
                      </div>
                      <div v-else-if="taskObj.task.i1 == 0" id="zmmtg-dynamic">
                        <zoom-detail :task="taskObj.task" />
                      </div>
                      <div v-else-if="taskObj.task.i1 == 1" id="zmmtg-dynamic">
                        <zoom-waiting :task="taskObj.task" :isStarted="zoomIsStarted" :course="course"
                          @on-detail="showTask" />
                      </div>
                      <div v-else-if="
                        taskObj.task.i1 == 2 &&
                        hasPermission(['learningteacher', 'learningadmin'])
                      ">
                        <zoom-detail :task="taskObj.task" />
                      </div>
                      <div v-else id="zmmtg-dynamic">
                        <zoom-waiting :task="taskObj.task" :isStarted="zoomIsStarted" :course="course"
                          @on-detail="showTask" />
                      </div>
                    </div>
                    <div v-if="boxOt == 125 && taskObj.rdy">
                      <forum-reply :id="taskObj.task.id" @on-attach="onAttach"></forum-reply>
                    </div>
                  </div>
                  <form-fill v-else-if="mode == 4 && boxOt == 389" backTo="course" @on-form-filled="onFormFilled"
                    :id="parseInt($route.params.iid, 10)" :boxId="parseInt($route.params.bid, 10)"
                    :boxOt="parseInt(boxOt, 10)" @form-page-rdy="cntntNoPdn = true" :prms="
                      course.boxes
                        .filter(x => x.id == $route.params.bid)[0]
                        .forms.filter(f => f.id == $route.params.iid)[0]
                    " />
                  <form-fill v-else-if="
                    mode == 4 &&
                    boxOt == 503 &&
                    (course.percent == 100 ||
                      course.boxes.filter(x => x.ot == 114)[0].tasks.length ==
                      0)
                  " backTo="course" @on-form-filled="onFormFilled" :id="parseInt($route.params.iid, 10)"
                    :boxId="parseInt($route.params.bid, 10)" :boxOt="parseInt(boxOt, 10)" @form-page-rdy="
                      cntntNoPdn = true;
                    getScrollHeight();
                                      " :prms="
                    course.boxes
                      .filter(x => x.id == $route.params.bid)[0]
                      .forms.filter(f => f.id == $route.params.iid)[0]
                  " />
                  <template v-else-if="mode == 4 && boxOt == 503 && course.percent != 100">
                    <div class="pd-20">
                      <div class="alert alert-warning" role="alert">
                        <h4 class="alert-heading">Мэдэгдэл</h4>
                        <p>
                          Бүх хичээлийг үзэж дуусгасны дараа үнэлгээ өгөх боломжтой.
                        </p>
                      </div>
                    </div>
                  </template>

                </div>


              </div>

              <!-- <team-preview
            v-if="rightSideActiveTab == 1 && course.teamId > 0 && showChatBox"
            :teamId="course.teamId"
            :obj="{ title: sendObjTitle() }"
            @on-attach="onAttach"
          />
          <task-notes
            v-else-if="course.id > 0"
            :taskId="course.id"
            @on-attach="onAttach"
            :obj="{ title: sendObjTitle(), name: course.name }"
          /> -->

            </div>
          </div>
        </b-modal>


      </div>


    </div>



    <b-sidebar v-model="sideBar.teamChat" title="Чат" shadow right width="100%">
      <div class="px-3 py-2 bg-white" v-if="sideBar.teamChat">
        <team-preview :teamId.sync="course.teamId" :obj="{ title: sendObjTitle() }" @on-attach="onAttach" />
      </div>
    </b-sidebar>

    <file-sidebar :id.sync="fileSidebar.id" :show="fileSidebar.show" @on-hide="
      fileSidebar.show = false;
    fileSidebar.id = 0;
            " />

    <re-buy-lesson :reBuyModal="reBuyModal" :itemId="parseInt($route.params.id, 10)" :course="course" :reBuyObj="reBuyObj"
      @on-hide="reBuyModal = false" />

    <b-modal v-model="teacherCourses.mdl" size="xl" scrollable hide-footer title="Багшийн бусад хичээлүүд" body-class="pd-0">
    <div class="">
      <div class="pd-b-50" style="background: #f5f6fa;">
        <div class="course-list pd-t-20-f pd-lg-x-80 pd-lg-xl-120 row list-list">
          <div v-for="(c, i) in teacherCourses.list" :key="`xx_t${i}`"
            class="course-item col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 col-xxl-3 pd-10">
            <router-link :to="{ name: 'lmsCourseView', params: { id: c.id, bid: 0, iid: 0, bot: 0 } }">
              <div class="bg-white pd-15 rounded-20 item-outer"><img
                  :src="`${c.cover}?w=200&h=120&mode=crop`"
                  class="cover rounded-20 wd-100p ht-120">
                <div class="item-info pd-10 d-flex align-items-center">
                  <div class="media">
                    <img class="rounded-circle mg-r-10 wd-60 ht-60"
                      :src="(c.teachers != null && c.teachers.length > 0) ? `${c.teachers[0].cover}?w=60&h=60&mode=crop` : 'assets/img/default.png?w=60&h=60&mode=crop'"
                    />
                  </div>
                  <div class="media-body">
                    <div :title="`${ c.name }`" class="tx-black tx-16 font-weight-bold lh-1">{{ c.name }}</div>
                    <div class="text-muted tx-10 mg-y-3" v-if="c.locType1!=null">{{ c.locType1.name }}</div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    </b-modal>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import vueCustomScrollbar from "vue-custom-scrollbar";

const moment = require("moment");
import { request } from "@/api/all";
var _ = require("lodash");

import "element-ui/lib/theme-chalk/index.css";
import { MessageBox, Tabs, TabPane, Notification, Rate } from "element-ui";

import { mapActions } from "vuex";
import { hasOneOf, getFileMode } from "@/libs/tools";

export default {
  components: {
    vueCustomScrollbar,
    Tabs,
    TabPane,
    Rate,
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    courseHeader: () => ({
      component: import(
        "@/views/modules/lms/student/components/headerCourse.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    reBuyLesson: () => ({
      component: import("@/views/modules/lms/student/components/rebuy.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    navDynamic: () => ({
      component: import(
        "@/views/modules/lms/student/components/navDynamic.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    // courseBox: () => ({
    //   component: import("@/views/modules/lms/student/components/boxCourse.vue"),
    //   loading: AsyncLoading,
    //   error: AsyncLoadError,
    //   delay: 100,
    //   timeout: 5000
    // }),
    zoomDetail: () => ({
      component: import("@/views/modules/lms/student/sections/zoomDetail.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    zoomWaiting: () => ({
      component: import("@/views/modules/lms/student/sections/zoomWaiting.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    teacherDetail: () => ({
      component: import(
        "@/views/modules/lms/student/sections/teacherDetail.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    teacherList: () => ({
      component: import("@/views/modules/lms/student/sections/teacherList.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    lessonList: () => ({
      component: import("@/views/modules/lms/student/sections/lessonList.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    zoomList: () => ({
      component: import("@/views/modules/lms/student/sections/zoomList.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    formList: () => ({
      component: import("@/views/modules/lms/student/sections/formList.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    formFill: () => ({
      component: import("@/components/modules/form/fill"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    forumList: () => ({
      component: import("@/views/modules/lms/student/sections/forumList.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    forumTopic: () => ({
      component: import("@/views/modules/lms/student/sections/forumTopic.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    forumReply: () => ({
      component: import("@/views/modules/lms/student/sections/forumReply.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    teamPreview: () => ({
      component: import("@/components/modules/team/embed.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    taskNotes: () => ({
      component: import("@/components/task/components/notes"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    courseOverview: () => ({
      component: import("@/views/modules/lms/student/sections/aboutCourse.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    courseCertificate: () => ({
      component: import("@/views/modules/lms/student/sections/courseCertificate.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    fileSidebar: () => ({
      component: import("@/components/modules/media/preview.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    courseNavbar: () => ({
      component: import(
        "@/views/modules/lms/student/components/courseAndLessonDetailNav.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    assignList: () => ({
      component: import("@/views/modules/lms/student/sections/assignList.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    jitsiDetail: () => ({
      component: import("@/views/modules/lms/student/sections/jitsiDetail.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    taskRating: () => ({
      component: import("@/components/task/components/actions/rate.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },

  data() {
    return {
      myResBaseUrl: "https://res.gosmart.mn/",
      v3mdl: false,
      hideLeftSide: false,
      firstLessonId: 0,
      fistLesson: {
        lid: 0,
        iid: 0,
        bid: 0,
        bot: 144,
      },
      activeSection: 1,
      dataRdy: false,
      mobileBtmBoxes: false,
      editableTabsValue: "tab_home",

      mode: 0,
      navbarMode: -10,
      sideBar: {
        teamChat: false
      },

      courseMode: {
        mode: 1,
        title: "Бүх нээлттэй сургалт"
      },
      cntntNoPdn: false,
      showRightSide: false,
      rightSideActiveTab: 1,
      showChatBox: false,
      course: {
        boxes: []
      },
      teacher: {},
      boxOt: null,
      boxObj: {
        box: {
          forms: [],
          attachments: [],
          tasks: [],
          attachmentsCount: 0,
          box: {}
        },
        rdy: false
      },
      taskObj: {
        task: {},
        rdy: false
      },
      fileSidebar: {
        show: false,
        id: 0
      },
      now: "",
      zoomIsStarted: false,
      expanded: true,
      rdy: false,
      cntntNoPdn: false,

      reBuyModal: false,
      reBuyObj: {},
      teacherCourses: {
        list: [],
        mdl: false
      }
    };
  },
  created() {
    if (
      this.$store.state.app.activeGroup.resBaseUrl != undefined &&
      this.$store.state.app.activeGroup.resBaseUrl != ""
    ) {
      this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
    }
  },
  mounted() {
    //console.log(this.$route.name);
    //this.toggleBodyClass("addClass", "app-course");
    //require("@/assets/scss/pages/course.scss");
    //getScrollHeight
    window.addEventListener("resize", this.getScrollHeight);
    //this.init();
    this.initCourse();

  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getScrollHeight);
  },
  destroyed() {
    Object.assign(this.$data, this.$options.data());
    //this.toggleBodyClass("removeClass", "app-course");
    //this.toggleBodyClass("removeClass", "dynamic-locker");
  },
  methods: {
    sectionManager(mode){
      let rv= false;
      if(this.$store.state.app.activeGroup.id!=9157){
        rv= true;
        return rv;
      }

      if(mode==0){
        rv= this.activeSection==1;
      } else if(mode ==1){
        rv= this.activeSection==2;
      } else if(mode ==2){
        rv= this.activeSection==3;
      } else if(mode ==3){
        rv= this.activeSection==4;
      }
       return rv;
    },
    onModalHide(){
      this.startCourse();
    },
    showCoursesByTeacher(tid) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "v2/Learn/GetCourses" },
        data: {
          skip: 0,
          size: 100,
          teacherId: tid
        },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.teacherCourses.list = res.data.courses;
          this.teacherCourses.mdl = true;
           //console.log('res', res.data.courses);
        }
      });
    },
    hasPermission(perrArr) {
      return hasOneOf(perrArr, this.$store.state.user.access);
    },
    jointToCourse() {
      if (this.course.option.directJoin == 1 || (this.course.option.joinType == 9900 && this.course.price == 0 && (this.$store.state.app.activeGroup.id == 9241 || this.$store.state.app.activeGroup.id == 9249))) {
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "POST", url: "TaskInUser/ShareTaskUser" },
          data: { userId: this.$store.state.user.userId, taskId: this.course.id },
          store: this.$store
        }).then(res => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            this.startCourse();
          }
        });
      } else {
        this.$router.push({ name: 'lmsAttend', params: { id: this.course.id, s1: 0, s2: 0 } });
      }
    },
    ...mapActions(["resetResponsiveLayoutConfig", "handleMainLayoutConfig"]),
    // toggleNav() {
    //   this.expanded = !this.expanded;
    // },
    // toggleRightSide()
    // {
    //   console.log('hi', this.showRightSide);
    //   this.showRightSide=!this.showRightSide;

    // },
    startCourse() {
      this.$router.push({
        name: "lmsLessonView",
        params: {
          id: this.firstLessonId,
          cid: this.$route.params.id,
          bid: 0,
          iid: 0,
          bot: 0
        }
      });
    },

    zoomHasNotStarted(conference) {
      request({
        api: { method: "get", url: "isintime" },
        params: {
          startDate: conference.dueStartDate,
          endDate: conference.dueDate
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          if (res.data.mode == 0) {
            this.showRightSide = false;
            this.zoomIsStarted = true;
          } else {
            this.showRightSide = true;
            this.zoomIsStarted = false;
            this.v3mdl = true;
            if (this.course.i5 == 1) this.showChatBox = true;
          }
          //console.log('======= ======= ======= ======= =======');
          if (this.$route.params.bot == 500 && this.$route.params.iid > 0) {
            if (this.zoomIsStarted) {
              this.hideLeftSide = true;
            } else {
              this.hideLeftSide = false;
            }
            //console.log('======= ======= ======= ======= =======', this.hideLeftSide);
          }
        }
      });
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    toggleTeamChat() {
      this.sideBar.teamChat = true;
    },
    init() {
      //console.log('course init fired', this.$route.name);
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "v2/Learn/CheckIsJoined" },
        params: { courseId: this.$route.params.id },
        //this.$route.name == "lmsLessonView" ? this.$route.params.cid : this.$route.params.id
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          //console.log('lesson CheckIsJoined', res.data.result);
          switch (res.data.result) {
            case -1:
              // MessageBox({
              //   title: "Мэдэгдэл",
              //   message: "Курсэд элсээгүй байна",
              //   showConfirmButton: false
              // });
              //        this.$bvToast.toast("Курсэд элсээгүй байна", {
              //   title: "Мэдэгдэл",
              //   autoHideDelay: 3000,
              //   appendToast: true,
              //   toaster: "b-toaster-top-right"
              // });

              Notification.success({
                message: "Сургалтад элсээгүй байна.",
                title: "Мэдэгдэл",
                duration: 3000,
                type: "info",
                position: "top-right",
                offset: 50
              });

              //this.$router.push({ name: "lmsParticipant" });
              //2022-04-04 BFA redirect url-tai bolgosnoor hervee elseegui bvl elseh huudas ru shiddeg bolgov
              this.$router.push({ name: "lmsAttend", params: { id: this.$route.params.id, s1: 0, s2: 0 } });

              break; //# elseegui bgaa
            case 1:
              this.initCourse();
              break;
            case 2:
              MessageBox({
                title: "Мэдэгдэл",
                //message: "Үргэлжлэх хугацаа эхлээгүй байна",
                message: "Сургалт эхлээгүй байгаа тул хандах боломжгүй",
                showConfirmButton: false
              });
              this.$router.push({ name: "lmsParticipant" });
              break; //# ehleegui bgaa
            case 3:
              this.showRightSide = false;
              MessageBox({
                title: "Мэдэгдэл",
                message: "Сургалт дууссан тул хандах боломжгүй",
                showConfirmButton: false
              });
              this.$router.push({ name: "lmsParticipant" });
              break; //# finished course
            default:
              break;
          }
        }
      });
    },
    initCourse() {
      let self = this;
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "V2/Learn/courseDetail" },
        params: { id: this.$route.params.id },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.dataRdy = true;
          //console.log('V2/Learn/courseDetail=> ', res.data.course.boxes.filter(x=>x.ot==114));
          //console.log('V2/Learn/courseDetail=> ', res.data.course);
          res.data.course.boxes.map(b => {
            if (b.ot == 114) {
              if (b.tasks.length) {
                // let _tt= b.tasks[0];
                // if(_tt.boxes.length){
                //   let _bb= _tt.boxes.filter(x=>x.attaches.length || x.tasks.length || x.form.length);



                //   console.log('b.tasks[0]', b.tasks[0]);
                // }
                self.firstLessonId = b.tasks[0]['id'];
                b.tasks.map(t => {
                  t.boxes.map(l => {

                    l.time = '';
                    l.timeIcon = '';
                    l.formatIcon = '';
                    //l.formatIcon= 'multimedia and audio/outline/camera video.svg';
                    if ((l.attaches != null && l.attaches.length > 0) || l.ot == 122) {
                      //console.log(t.task+' l.attaches!=null ', l.nm)
                      if (l.ot == 122 || l.ot == 286) {
                        l.timeIcon = 'interface/outline/clock-rectangle-1.svg';
                        l.time = `${(l.attaches.filter(z => z.dur != null).reduce((sum, st) => sum + parseInt(st.dur), 0) / 60).toFixed(0).padStart(2, "0")}:${(l.attaches.filter(z => z.dur != null).reduce((sum, st) => sum + parseInt(st.dur), 0) % 60).toFixed(0).padStart(2, "0")}<sup>мин</sup>`;
                        l.format = 'Видео';
                        l.formatIcon = 'multimedia and audio/outline/camera video.svg';
                      }
                      //  else if(l.ot==6){
                      //   l.formatIcon= 'files and folder/outline/folder 03.svg';
                      //   l.format= 'Файл';
                      // }
                      else {
                        l.timeIcon = 'files and folder/outline/files 01.svg';
                        l.time = self.displaySize(l.attaches.filter(z => z.s != null).reduce((sum, st) => sum + parseInt(st.s), 0));
                        l.formatIcon = 'files and folder/outline/folder 03.svg';
                        //l.format = 'Файл' + l.ot;
                        l.format = 'Файл';
                      }

                      // if (getFileMode(e) == "document" || getFileMode(e) == "pdfObject") {
                      //   rv = "Унших";
                      // } else if (getFileMode(e) == "video") {
                      //   rv = "Видео";
                      // } else if (getFileMode(e) == "image") {
                      //   rv = "Зураг";
                      // } else if (e == "mp3") rv = "Аудио";

                    } else if (l.forms != null && l.forms.length > 0) {

                      //console.log(b.nm+'l.forms!=null ', l.nm, l.forms.filter(z=>z.qCount>0))
                      //console.log(b.nm+'l.forms!=null ', l.nm, l.forms.filter(x=>x.qCount>0).reduce((sum, st) => sum + parseInt(st.qCount), 0));
                      l.time = l.forms.filter(x => x.qCount > 0).reduce((sum, st) => sum + parseInt(st.qCount), 0) + '<sup>асуулт</sup>';
                      l.timeIcon = 'education/outline/quiz.svg';
                      if (l.ot == 117) {
                        l.format = 'Тест';
                      } else if (l.ot == 416) {
                        l.format = 'Явцын шалгалт';
                      } else {
                        l.format = 'Форм';
                      }
                      l.formatIcon = 'education/outline/fountain pen.svg';
                    } else if (l.tasks != null && l.tasks.length > 0) {
                      if (l.ot == 127) {
                        l.time = l.tasks.length;
                        l.timeIcon = 'interface/outline/layers.svg';
                        l.formatIcon = 'interface/outline/share-rectangle.svg';
                        l.format = 'Холбоос';
                      } else {
                        l.format = 'Бусад';
                        //console.log(l.nm, l);
                      }
                    } else {
                      //console.log(t.task+' ene yu ve ', l.nm)
                    }
                  });

                });
                if (this.$store.state.app.isMobile) {
                  b.tasks = b.tasks.filter(x => x.i2 != 1);
                }
                let _obj = _.maxBy(
                  b.tasks.filter(x => x.im != null),
                  function (t) {
                    return t.im.lastViewDate;
                  }
                );
                if (
                  _obj != undefined &&
                  _obj != null &&
                  _obj.id != undefined &&
                  _obj.id != null
                ) {
                  b.tasks.filter(x => x.id == _obj.id)[0].resume = true;
                }
              }
              b.icon = "menu";
            } else if (b.ot == 116) b.icon = "pen-tool";
            else if (b.ot == 124) b.icon = "message-square";
            else if (b.ot == 389) b.icon = "clipboard";
            else if (b.ot == 503) b.icon = "clipboard";
            else if (b.ot == 396) {
              b.icon = "users";
              if (b.tasks.length) {
                //# 2021.1.18 bagshiin neren deer darhaar coused elseegui bn gd 0 id ruu yavaad bhaar zassan
                res.data.course.teachers[0].boxId = b.id;

                this.teacher.has = true;
                this.teacher.profile = b.tasks[0].defaultAttachmentUrl;
                this.teacher.fullname =
                  b.tasks[0].taskEn + " " + b.tasks[0].task;
                this.teacher.info = b.tasks[0].position;
              }
            } else if (b.ot == 397) b.icon = "info";
            else if (b.ot == 493) b.icon = "video";
            else if (b.ot == 500) b.icon = "video";
          });
          this.course = res.data.course;
          console.log('this.course', this.course);
          this.rdy = true;
          this.$nextTick(() => {
            this.editableTabsValue = "tab_home";
            this.initCourseStatus();
            this.initAfter();
          });
        }
      });
    },
    initCourseStatus() {
      if (this.course.flag1 == 9900) {
        this.courseMode = {
          mode: 2,
          title: "Заавал хамрагдах сургалт"
        };
      } else if (this.course.isJoined) {
        var startDate = moment(this.course.date.start),
          endDate = moment(this.course.date.end),
          date = moment(this.course.date.now); //range = moment().range(startDate, endDate);
        if (date.isBetween(startDate, endDate)) {
          this.courseMode = {
            mode: 3,
            title: "Миний үзэж буй сургалт"
          };
        } else {
          this.courseMode = {
            mode: 4,
            title: "Миний дууссан сургалт"
          };
        }
        //date.now
      }
    },
    initAfter() {
      //console.log('init after fired');
      if (this.$route.params.bid > 0 && this.$route.params.iid == 0) {
        this.mode = 1;
        this.initBox(this.$route.params.bid, this.$route.params.bot);
      } else if (
        this.$route.params.bid > 0 &&
        this.$route.params.iid > 0 &&
        this.$route.params.bot == 6
      ) {
        this.mode = 2;
        //this.showAttach(this.$route.params.iid);
      }
      //# forum yed hairtsgaa oloh gd detail duudah bolov
      // else if(this.$route.params.bid>0 && this.$route.params.iid>0 && this.$route.params.bot==124){
      //   this.mode=2;
      //   this.initBox(this.$route.params.bid, this.$route.params.bot, this.$route.params.iid);
      // }
      else if (
        this.$route.params.bid > 0 &&
        this.$route.params.iid > 0 &&
        (this.$route.params.bot == 124 ||
          this.$route.params.bot == 396 ||
          this.$route.params.bot == 125 ||
          this.$route.params.bot == 493 ||
          this.$route.params.bot == 500 ||
          this.$route.params.bot == 516)
      ) {
        this.mode = 3;
        this.showTask(this.$route.params.iid);
        if (this.$route.params.bot == 124) {
          this.boxObj.box = {
            box: this.course.boxes.filter(
              x => x.id == this.$route.params.bid
            )[0]
          };
        } else if (this.$route.params.bot == 125 && this.course.i5 == 1) {
          this.showChatBox = true;
        } else if (this.$route.params.bot == 493 && this.course.i5 == 1) {
          this.showChatBox = true;
        }
      } else if (
        this.$route.params.bid > 0 &&
        this.$route.params.iid > 0 &&
        (this.$route.params.bot == 389 || this.$route.params.bot == 503)
      ) {
        this.mode = 4;
        this.boxOt = this.$route.params.bot;
      } else if (this.$route.params.bot == -7) {
        //console.log('im here');
        //this.cntntNoPdn=true;
        this.mode = -7;
      } else {
        if (this.course.i5 == 1) this.showChatBox = true;
      }
    },
    initBox(boxId, bot) {
      if (bot == 502) {
        this.boxObj.rdy = true;
        if (this.course.i5 == 1) this.showChatBox = true;
      }
      this.editableTabsValue = `tab_${boxId}`;
      this.boxOt = bot;
      if (bot == 114 || bot == 124 || bot == 125 || bot == 493 || bot == 500) {
        if (this.course.i5 == 1) this.showChatBox = true;
      }

      if (bot == 114 || bot == 396 || bot == 493 || bot == 500) {
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "POST", url: "taskCore/coreBoxInTaskList" },
          data: {
            id: boxId,
            skip: 0,
            size: 100
          },
          store: this.$store
        }).then(res => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            this.boxObj.box = res.data;
            this.boxObj.rdy = true;
          }
        });
      } else if (
        bot == 116 ||
        bot == 124 ||
        bot == 125 ||
        bot == 389 ||
        bot == 503
      ) {
        let _ta = this.course.boxes.filter(x => x.ot == bot);
        if (bot == 116) {
          this.boxObj.box = {
            forms: _ta.length > 0 ? _ta[0].forms : [],
            box:
              this.course.boxes.filter(x => x.id == boxId).length > 0
                ? this.course.boxes.filter(x => x.id == boxId)[0]
                : []
          };
        } else if (bot == 124 || bot == 125) {
          this.boxObj.box = {
            tasks: _ta.length > 0 ? _ta[0].tasks : [],
            box: _ta.length > 0 ? _ta[0] : {}
          };
        } else if (bot == 389 || bot == 503) {
          this.boxObj.box = {
            forms: _ta.length > 0 ? _ta[0].forms : [],
            box:
              this.course.boxes.filter(x => x.id == boxId).length > 0
                ? this.course.boxes.filter(x => x.id == boxId)[0]
                : []
          };
        }
        this.boxObj.rdy = true;
      }
    },
    showTask(id) {
      // console.log('showTask', id);
      this.editableTabsValue = `tab_${this.$route.params.bid}`;
      this.boxOt = this.$route.params.bot;
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "task/taskInheritedDetail" },
        params: { id: id },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        // console.log('res.ios != undefined && res.ios && this.$route.params.bot == 493', res.ios != undefined && res.ios && this.$route.params.bot == 493)
        if (res.ios != undefined && res.ios && this.$route.params.bot == 493) {
          //window.open('https://demo.gosmart.mn', '_blank');
          this.$router.push({
            name: "lmsCourseView",
            params: { id: this.$route.params.id, bid: 0, iid: 0, bot: 0 }
          });
          this.$bvToast.toast(
            `Та Динамик платформ апп-н шинэчлэлтийг татна уу. Эсвэл гар утасны броузер-с [${this.$store.state.app.activeGroup.hostPro[0]}] холбоосоор хандана уу`,
            {
              title: "Мэдэгдэл",
              autoHideDelay: 5000,
              appendToast: false,
              variant: "info",
              toaster: "b-toaster-top-center"
            }
          );
        } else {
          if (res != false) {
            if (this.$route.params.bot == 500) {
              this.zoomHasNotStarted(res.data.task);
            } else if (this.$route.params.bot == 516) {
              window.open(res.data.task.taskEn, "_blank");
              //this.init();
              //this.zoomHasNotStarted(res.data.task);
            } else if (this.$route.params.bot == 493) {
              this.v3mdl = true;
              // console.log('493 yed yu hiih ve');
            }
            this.taskObj.task = res.data.task;
            this.taskObj.rdy = true;
          }
        }
      });
    },
    showDetail(a, box) {
      if (this.boxOt == 114) {
        this.$router.push({
          name: "lmsLessonView",
          params: {
            id: a.id,
            cid: this.$route.params.id,
            bid: 0,
            iid: 0,
            bot: 0
          }
        });
      } else {
        if (a.objectTypeId == 125) {
          this.$router.push({
            name: "lmsCourseView",
            params: {
              id: this.$route.params.id,
              bid: box.id,
              iid: a.id,
              bot: 125
            }
          });
        } else {
          //console.log('showDetail showDetail', a, box);
          if (box.ot != undefined && box.ot == 516) {
            window.open(a.taskEn, "_blank");
          } else {
            this.$router.push({
              name: "lmsCourseView",
              params: {
                id: this.$route.params.id,
                bid: box.id,
                iid: a.id,
                bot: box.objectTypeId
              }
            });
          }
        }
      }
    },
    showFormFill() { },
    onFormFilled(e) {
      let curBox = this.course.boxes.filter(x => x.id == e.boxId);
      if (curBox.length) {
        let curForm = curBox[0].forms.filter(x => x.id == e.id);
        if (curForm.length) {
          curForm[0].fillingCount = e.fillingCount;
        }
      }
    },
    onAttach(e) {
      this.fileSidebar.id = parseInt(e, 10);
      this.fileSidebar.show = true;
    },
    showExamResult(e) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "learn/GetExamResult" },
        params: { courseId: this.$route.params.id, examId: e },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          let _txt = "";
          if (res.data.examCode == 1) {
            _txt =
              res.data.msg +
              " " +
              ((res.data.truePoint * 100) / res.data.questionPoint).toFixed(2) +
              "%";
          } else if (res.data.examCode == 2) {
            _txt = "Шалгалтын огноо эхлээгүй/дуусаагүй байна";
          } else if (res.data.examCode == 3 || res.data.examCode == 6) {
            _txt = "Шалгалтын үр дүнг харах боломжгүй";
          } else if (res.data.examCode == 4) {
            _txt = "Шалгалтын үр дүнг илгээгээгүй";
          } else {
            _txt = "Шалгалтын өгөгдөл илгээсэн байна";
          }

          MessageBox({
            title: "Дүн харах",
            message: _txt,
            showConfirmButton: false
          });
        }
      });
    },
    sendObjTitle() {
      let rv = "";

      if (this.$route.params.iid > 0) {
        rv =
          this.course.boxes.filter(b => b.id == this.$route.params.bid)[0].nm +
          " > " +
          this.getBreadcrumbTitle();
      } else if (
        this.$route.params.bid > 0 &&
        this.course.boxes.filter(b => b.id == this.$route.params.bid).length
      ) {
        rv =
          this.course.name +
          " > " +
          this.course.boxes.filter(b => b.id == this.$route.params.bid)[0].nm;
      } else {
        rv = this.course.name;
      }

      return rv;
    },
    getBreadcrumbTitle() {
      let rv = "";
      let _b = this.course.boxes.filter(b => b.id == this.$route.params.bid);
      if (_b.length) {
        if (_b[0].tasks.length) {
          let _i = _b[0].tasks.filter(x => x.id == this.$route.params.iid);
          if (_i.length) rv = _i[0].task;
        } else if (_b[0].forms.length) {
          let _i = _b[0].forms.filter(x => x.id == this.$route.params.iid);
          if (_i.length) rv = _i[0].nm;
        } else if (_b[0].attaches.length) {
          let _i = _b[0].attaches.filter(x => x.id == this.$route.params.iid);
          if (_i.length) rv = _i[0].t != "" ? _i[0].t : _i[0].n;
        }
      }
      return rv;
    },
    closeLevel2() {
      if (this.$store.state.app.responsiveLayout.level2.show)
        this.resetResponsiveLayoutConfig(document);
    },
    getScrollHeight() {
      let mh = 0;
      // if (screen.width <= 1024) {
      //   mh = 115;
      // } else if (this.mode == 4) {
      //   mh = 115;
      // } 
      // else if (this.mode == -7) {
      //   mh = 115;
      // }
      // if (this.$store.state.app.isMobile) {
      //   mh = 60;
      // }

      // if (this.$store.state.app.mainLayoutConfig.expanded) {
      //   mh = 0;
      // }

      // if (this.cntntNoPdn) {
      //   mh = 115;
      // }
      //console.log('mh', mh);

      return `calc(${window.innerHeight}px - ${mh}px) !important;`;
    },
    tabClicked(e) {
      if (e.name.split("_")[1] == "home") {
        this.$router.push({
          name: "lmsCourseView",
          params: { id: this.$route.params.id, bid: 0, iid: 0, bot: 0 }
        });
      } else {
        let curb = this.course.boxes.filter(x => x.id == e.name.split("_")[1]);
        if (curb.length) {
          this.$router.push({
            name: "lmsCourseView",
            params: {
              id: this.$route.params.id,
              bid: curb[0].id,
              iid: 0,
              bot: curb[0].ot
            }
          });
        }
      }
    },
    toggleContent(e) {
      // let _obj = this.$store.state.app.mainLayoutConfig;
      // if (e != undefined && e) {
      //   this.expanded = true;
      //   this.showRightSide = true;
      //   _obj.header = 2;
      //   _obj.expanded = false;
      // } else {
      //   this.expanded = false;
      //   this.showRightSide = false;
      //   _obj.header = null;
      //   _obj.expanded = true;
      // }
      // this.handleMainLayoutConfig(_obj);
      // this.$nextTick(() => {
      //   this.getScrollHeight();
      // });
    },

    onRebuy(lesson) {
      //console.log('open rebuy');
      this.reBuyObj = lesson;
      this.reBuyModal = true;
    },
    displaySize(kb) {
      let rv = '';
      if (kb > 1024) {
        rv = ((kb / 1024) / 1024).toFixed(2) + '<sup>mb</sup>';
      } else {
        rv = (kb / 1024).toFixed(2) + '<sup>kb</sup>';
      }
      return rv;
    }
  },
  watch: {
    "$root.$route"() {
      let _tmp = this.$data.expanded;
      let _tmpRight = this.$data.showRightSide;
      Object.assign(this.$data, this.$options.data());
      this.$data.expanded = _tmp;
      this.$data.showRightSide = _tmpRight;
      //console.log('newRoute.params', newRoute.params);
      //if(newRoute.params.cid!=oldRoute.params.cid){
      this.$nextTick(() => {
        this.init();
      });
      //}

      // this.$nextTick(() => {
      //   this.init();
      // });
    }
  }
};
</script>

<style lang="scss" scoped>
.msg-ind {
  display: flex;
  width: 20px;
  height: 20px;
  justify-content: center;
  position: absolute;
  top: -6px;
  right: -8px;
  background-color: #dc3545;
  color: #fff;
  font-size: 10px;
  font-weight: 400;
  font-family: sans-serif;
  line-height: 2;
  border-radius: 100%;
}
</style>
